/*==================================================
  Gentlemen's Club
  Core Module
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

    const hero = document.querySelector("#gc-hero");

    if (!hero) return;

    const intro = document.querySelector("#gcIntro");
    const skipButton = document.querySelector(".gc-skip-intro");

    const STORAGE_KEY = "gc_intro_seen";

    const prefersReducedMotion =
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;





    /*-----------------------------------------
      Disable Intro
    -----------------------------------------*/

    function finishIntro() {

        if (!intro) return;

        intro.classList.add("gc-hide");

        document.documentElement.classList.remove("gc-lock");

        document.body.classList.remove("gc-lock");

        hero.classList.add("gc-ready");

    }





    /*-----------------------------------------
      Save State
    -----------------------------------------*/

    function completeIntro() {

        localStorage.setItem(STORAGE_KEY, "true");

        finishIntro();

    }





    /*-----------------------------------------
      Skip Button
    -----------------------------------------*/

    if (skipButton) {

        skipButton.addEventListener("click", completeIntro);

    }





    /*-----------------------------------------
      Don't replay intro
    -----------------------------------------*/

    const introSeen = localStorage.getItem(STORAGE_KEY);

    if (introSeen === "true") {

        finishIntro();

        return;

    }





    /*-----------------------------------------
      Accessibility
    -----------------------------------------*/

    if (prefersReducedMotion) {

        completeIntro();

        return;

    }





    /*-----------------------------------------
      Lock Scroll
    -----------------------------------------*/

    document.documentElement.classList.add("gc-lock");

    document.body.classList.add("gc-lock");





    /*-----------------------------------------
      Animation Timeline
    -----------------------------------------*/

    setTimeout(() => {

        intro.classList.add("gc-show-monogram");

    }, 300);





    setTimeout(() => {

        intro.classList.add("gc-show-box");

    }, 1200);





    setTimeout(() => {

        intro.classList.add("gc-open-box");

    }, 2200);





    setTimeout(() => {

        intro.classList.add("gc-show-light");

    }, 2900);





    setTimeout(() => {

        intro.classList.add("gc-zoom");

    }, 3600);





    setTimeout(() => {

        completeIntro();

    }, 4600);

});
/*==================================================
  Gentlemen's Club
  Scroll Module
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

    const hero = document.querySelector("#gc-hero");

    if (!hero) return;

    const heroMedia = hero.querySelector(".gc-hero-media");
    const heroContent = hero.querySelector(".gc-hero-content");
    const scrollIndicator = hero.querySelector(".gc-scroll");

    const revealElements = document.querySelectorAll(
        ".gc-reveal"
    );





    /*---------------------------------------
      Smooth Scroll
    ---------------------------------------*/

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {

        anchor.addEventListener("click", function(e){

            const target = document.querySelector(
                this.getAttribute("href")
            );

            if(!target) return;

            e.preventDefault();

            target.scrollIntoView({

                behavior:"smooth",
                block:"start"

            });

        });

    });





    /*---------------------------------------
      Scroll Animation
    ---------------------------------------*/

    let lastScroll = 0;
    let ticking = false;

    function updateScroll(){

        const scrollY = window.pageYOffset;





        /*------------------------------
          Hero Parallax
        ------------------------------*/

        if(heroMedia){

            heroMedia.style.transform =
                `translateY(${scrollY * 0.18}px) scale(1.08)`;

        }

        if(heroContent){

            heroContent.style.transform =
                `translateY(${scrollY * 0.10}px)`;

        }





        /*------------------------------
          Scroll Indicator
        ------------------------------*/

        if(scrollIndicator){

            if(scrollY > 80){

                scrollIndicator.classList.add("gc-hidden");

            }else{

                scrollIndicator.classList.remove("gc-hidden");

            }

        }





        lastScroll = scrollY;

        ticking = false;

    }

    window.addEventListener("scroll", ()=>{

        if(!ticking){

            requestAnimationFrame(updateScroll);

            ticking = true;

        }

    });





    /*---------------------------------------
      Reveal Sections
    ---------------------------------------*/

    const observer = new IntersectionObserver(

        (entries)=>{

            entries.forEach(entry=>{

                if(entry.isIntersecting){

                    entry.target.classList.add("gc-visible");

                }

            });

        },

        {

            threshold:0.18,

            rootMargin:"0px 0px -80px 0px"

        }

    );



    revealElements.forEach(el=>{

        observer.observe(el);

    });





    /*---------------------------------------
      Mouse Parallax
    ---------------------------------------*/

    hero.addEventListener("mousemove",(e)=>{

        const x = (e.clientX/window.innerWidth)-0.5;

        const y = (e.clientY/window.innerHeight)-0.5;

        if(heroMedia){

            heroMedia.style.transform =

                `translate(${x*18}px,${y*18}px)
                 scale(1.08)`;

        }

        if(heroContent){

            heroContent.style.transform =

                `translate(${x*8}px,${y*8}px)`;

        }

    });





    hero.addEventListener("mouseleave",()=>{

        if(heroMedia){

            heroMedia.style.transform="translate(0,0) scale(1.08)";

        }

        if(heroContent){

            heroContent.style.transform="translate(0,0)";

        }

    });

});
/*==================================================
  Gentlemen's Club
  Interaction Module
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

    /*=========================================
      Cursor Glow
    =========================================*/

    const glow = document.querySelector(".gc-cursor-glow");

    if (glow && window.innerWidth > 991) {

        let mouseX = 0;
        let mouseY = 0;

        let glowX = 0;
        let glowY = 0;

        document.addEventListener("mousemove", (e) => {

            mouseX = e.clientX;
            mouseY = e.clientY;

        });

        function animateGlow() {

            glowX += (mouseX - glowX) * 0.15;
            glowY += (mouseY - glowY) * 0.15;

            glow.style.transform =
                `translate(${glowX}px, ${glowY}px)`;

            requestAnimationFrame(animateGlow);

        }

        animateGlow();

    }





    /*=========================================
      Magnetic Buttons
    =========================================*/

    const buttons = document.querySelectorAll(".gc-btn");

    buttons.forEach(button => {

        button.addEventListener("mousemove", e => {

            const rect = button.getBoundingClientRect();

            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            const moveX = (x - rect.width / 2) / 8;
            const moveY = (y - rect.height / 2) / 8;

            button.style.transform =
                `translate(${moveX}px, ${moveY}px) scale(1.04)`;

        });

        button.addEventListener("mouseleave", () => {

            button.style.transform =
                "translate(0,0) scale(1)";

        });

    });





    /*=========================================
      Product Card Hover
    =========================================*/

    const cards = document.querySelectorAll(".gc-product-card");

    cards.forEach(card => {

        const image = card.querySelector("img");

        card.addEventListener("mouseenter", () => {

            card.classList.add("gc-hover");

            if (image) {

                image.style.transform =
                    "scale(1.08)";

            }

        });

        card.addEventListener("mouseleave", () => {

            card.classList.remove("gc-hover");

            if (image) {

                image.style.transform =
                    "scale(1)";

            }

        });

    });





    /*=========================================
      Luxury Hover Shine
    =========================================*/

    const shineCards = document.querySelectorAll(".gc-product-card");

    shineCards.forEach(card => {

        card.addEventListener("mousemove", e => {

            const rect = card.getBoundingClientRect();

            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            card.style.setProperty("--x", x + "px");
            card.style.setProperty("--y", y + "px");

        });

    });





    /*=========================================
      Video Pause When Hidden
    =========================================*/

    const heroVideo = document.querySelector(".gc-video");

    if (heroVideo) {

        const videoObserver = new IntersectionObserver(entries => {

            entries.forEach(entry => {

                if (entry.isIntersecting) {

                    heroVideo.play().catch(() => {});

                } else {

                    heroVideo.pause();

                }

            });

        }, {

            threshold: 0.25

        });

        videoObserver.observe(heroVideo);

    }





    /*=========================================
      Floating Particles
    =========================================*/

    const particles = document.querySelectorAll(".gc-particles span");

    particles.forEach((particle, index) => {

        const speed = 8 + (index * 2);

        particle.animate(

            [

                {
                    transform: "translateY(0px)",
                    opacity: .25
                },

                {
                    transform: `translateY(-${speed * 8}px)`,
                    opacity: .8
                },

                {
                    transform: `translateY(-${speed * 16}px)`,
                    opacity: 0
                }

            ],

            {

                duration: 3500 + (index * 600),

                iterations: Infinity,

                easing: "ease-in-out"

            }

        );

    });





    /*=========================================
      Reveal Hero Text
    =========================================*/

    const heroContent = document.querySelector(".gc-content-inner");

    if (heroContent) {

        setTimeout(() => {

            heroContent.classList.add("gc-content-visible");

        }, 4300);

    }





    /*=========================================
      Premium Link Hover
    =========================================*/

    const links = document.querySelectorAll("a");

    links.forEach(link => {

        link.addEventListener("mouseenter", () => {

            document.body.classList.add("gc-link-hover");

        });

        link.addEventListener("mouseleave", () => {

            document.body.classList.remove("gc-link-hover");

        });

    });

});
/*==================================================
  Gentlemen's Club
  Performance Module
==================================================*/

document.addEventListener("DOMContentLoaded", () => {

    const html = document.documentElement;

    /*=========================================
      Reduced Motion
    =========================================*/

    const prefersReducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
    );

    function handleReducedMotion(e) {

        if (e.matches) {

            html.classList.add("gc-reduced-motion");

            document.querySelectorAll("video").forEach(video => {

                video.pause();

            });

        } else {

            html.classList.remove("gc-reduced-motion");

            document.querySelectorAll("video").forEach(video => {

                video.play().catch(() => {});

            });

        }

    }

    handleReducedMotion(prefersReducedMotion);

    prefersReducedMotion.addEventListener(
        "change",
        handleReducedMotion
    );





    /*=========================================
      Resize Observer
    =========================================*/

    const hero = document.querySelector("#gc-hero");

    if (hero && window.ResizeObserver) {

        const resizeObserver = new ResizeObserver(() => {

            document.documentElement.style.setProperty(
                "--gc-window-height",
                `${window.innerHeight}px`
            );

        });

        resizeObserver.observe(hero);

    }





    /*=========================================
      Debounced Resize
    =========================================*/

    let resizeTimer;

    window.addEventListener("resize", () => {

        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {

            document.documentElement.style.setProperty(
                "--gc-window-height",
                `${window.innerHeight}px`
            );

        }, 150);

    });





    /*=========================================
      Page Visibility API
    =========================================*/

    document.addEventListener("visibilitychange", () => {

        const videos = document.querySelectorAll("video");

        if (document.hidden) {

            videos.forEach(video => {

                video.pause();

            });

        } else {

            videos.forEach(video => {

                video.play().catch(() => {});

            });

        }

    });





    /*=========================================
      Lazy Video Loading
    =========================================*/

    const lazyVideos = document.querySelectorAll("video");

    const videoObserver = new IntersectionObserver(

        entries => {

            entries.forEach(entry => {

                const video = entry.target;

                if (entry.isIntersecting) {

                    video.play().catch(() => {});

                } else {

                    video.pause();

                }

            });

        },

        {

            threshold: 0.15

        }

    );

    lazyVideos.forEach(video => {

        videoObserver.observe(video);

    });





    /*=========================================
      Cleanup Before Leaving
    =========================================*/

    window.addEventListener("beforeunload", () => {

        document.querySelectorAll("video").forEach(video => {

            video.pause();

        });

    });





    /*=========================================
      Idle Callback
    =========================================*/

    if ("requestIdleCallback" in window) {

        requestIdleCallback(() => {

            document.body.classList.add("gc-loaded");

        });

    } else {

        setTimeout(() => {

            document.body.classList.add("gc-loaded");

        }, 1000);

    }





    /*=========================================
      Memory Cleanup
    =========================================*/

    window.addEventListener("pagehide", () => {

        document.querySelectorAll("video").forEach(video => {

            video.pause();

            video.removeAttribute("src");

            while (video.firstChild) {

                video.removeChild(video.firstChild);

            }

            video.load();

        });

    });

});
/* ===========================
   STORY REVEAL
=========================== */

const story = document.querySelector('.gc-story');

if (story) {

    const observer = new IntersectionObserver((entries)=>{

        entries.forEach(entry=>{

            if(entry.isIntersecting){

                story.classList.add('in-view');

            }

        });

    },{
        threshold:0.25
    });

    observer.observe(story);

}
/* ===========================
   CRAFTSMANSHIP REVEAL
=========================== */

const craft = document.querySelector('.gc-craftsmanship');

if(craft){

    const observer = new IntersectionObserver((entries)=>{

        entries.forEach(entry=>{

            if(entry.isIntersecting){
                craft.classList.add('in-view');
            }

        });

    },{ threshold:0.2 });

    observer.observe(craft);
}

/* ========================================
   GENTLEMEN'S CLUB PRODUCT PAGE
======================================== */

document.addEventListener("DOMContentLoaded", function () {

  const productPage = document.querySelector("#gcp-product");
  if (!productPage) return;

  /* Gallery thumbnails */
  const mainImage = productPage.querySelector("#gcpMainImage");
  const thumbs = productPage.querySelectorAll(".gcp-thumb");

  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", function () {
      thumbs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      if (mainImage && this.dataset.image) {
        mainImage.style.opacity = "0";

        setTimeout(() => {
          mainImage.src = this.dataset.image;
          mainImage.style.opacity = "1";
        }, 180);
      }
    });
  });

  /* Quantity selector */
  const minus = productPage.querySelector(".gcp-qty-minus");
  const plus = productPage.querySelector(".gcp-qty-plus");
  const qty = productPage.querySelector(".gcp-qty input");

  if (minus && plus && qty) {
    minus.addEventListener("click", function () {
      qty.value = Math.max(1, parseInt(qty.value || "1", 10) - 1);
    });

    plus.addEventListener("click", function () {
      qty.value = parseInt(qty.value || "1", 10) + 1;
    });
  }

  /* Sticky info reveal */
  const info = productPage.querySelector(".gcp-info");
  const gallery = productPage.querySelector(".gcp-gallery");

  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("gcp-visible");
      }
    });
  }, { threshold: 0.15 });

  if (info) revealObserver.observe(info);
  if (gallery) revealObserver.observe(gallery);

  /* Accordion polish */
  const details = productPage.querySelectorAll(".gcp-accordion details");

  details.forEach((item) => {
    item.addEventListener("toggle", function () {
      if (item.open) {
        details.forEach((other) => {
          if (other !== item) other.removeAttribute("open");
        });
      }
    });
  });

  /* Mobile sticky add button */
  const addButton = productPage.querySelector(".gcp-btn-primary");

  if (addButton && window.innerWidth <= 768) {
    const stickyBar = document.createElement("div");
    stickyBar.className = "gcp-mobile-sticky";

    stickyBar.innerHTML = `
      <button type="button" class="gcp-btn gcp-btn-primary">
        ${addButton.innerText}
      </button>
    `;

    document.body.appendChild(stickyBar);

    stickyBar.querySelector("button").addEventListener("click", function () {
      addButton.click();
    });
  }

});
/* ========================================
   GCP PRODUCT PAGE — CURSOR / TOUCH REACTION
======================================== */

document.addEventListener("DOMContentLoaded", function () {
  const productPage = document.querySelector("#gcp-product");
  if (!productPage) return;

  if (productPage.dataset.gcpHoverReady === "true") return;
  productPage.dataset.gcpHoverReady = "true";

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReducedMotion) return;

  const isTouchDevice = window.matchMedia("(hover: none), (pointer: coarse)").matches;

  const targets = productPage.querySelectorAll(
    ".gcp-main-image, .gcp-thumb, .gcp-btn, .gcp-accordion summary"
  );

  function setPointerPosition(element, clientX, clientY) {
    const rect = element.getBoundingClientRect();

    const x = clientX - rect.left;
    const y = clientY - rect.top;

    element.style.setProperty("--gcp-x", `${x}px`);
    element.style.setProperty("--gcp-y", `${y}px`);

    if (!isTouchDevice && element.classList.contains("gcp-main-image")) {
      const rotateX = ((y / rect.height) - 0.5) * -5;
      const rotateY = ((x / rect.width) - 0.5) * 5;

      element.style.transform =
        `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
    }
  }

  function resetElement(element) {
    element.classList.remove("gcp-is-hovered", "gcp-is-pressed");

    if (element.classList.contains("gcp-main-image")) {
      element.style.transform = "perspective(900px) rotateX(0deg) rotateY(0deg)";
    }
  }

  targets.forEach(function (element) {
    element.classList.add("gcp-reactive");

    element.addEventListener("pointerenter", function (event) {
      element.classList.add("gcp-is-hovered");
      setPointerPosition(element, event.clientX, event.clientY);
    });

    element.addEventListener("pointermove", function (event) {
      element.classList.add("gcp-is-hovered");
      setPointerPosition(element, event.clientX, event.clientY);
    });

    element.addEventListener("pointerleave", function () {
      resetElement(element);
    });

    element.addEventListener("pointerdown", function (event) {
      element.classList.add("gcp-is-hovered", "gcp-is-pressed");
      setPointerPosition(element, event.clientX, event.clientY);
    });

    element.addEventListener("pointerup", function () {
      element.classList.remove("gcp-is-pressed");

      if (isTouchDevice) {
        setTimeout(function () {
          element.classList.remove("gcp-is-hovered");
        }, 350);
      }
    });

    element.addEventListener("pointercancel", function () {
      resetElement(element);
    });
  });
});
/* ========================================
   GC HOME ENTRY — BOX OPENING REDIRECT
======================================== */

document.addEventListener("DOMContentLoaded", function () {
  const triggers = document.querySelectorAll("[data-gc-entry-trigger]");

  if (!triggers.length) return;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", function (event) {
      const section = trigger.closest("[data-gc-home-entry]");
      if (!section) return;

      const door = section.querySelector("[data-gc-home-door]");
      const targetUrl = trigger.getAttribute("href");

      if (!door || !targetUrl || prefersReducedMotion) return;

      event.preventDefault();

      door.classList.add("is-active");

      setTimeout(function () {
        door.classList.add("is-opening");
      }, 450);

      setTimeout(function () {
        door.classList.add("is-entering");
      }, 2150);

      setTimeout(function () {
        window.location.href = targetUrl;
      }, 2850);
    });
  });
});
